import React, { useEffect, useState } from "react";
import DetailLayout from "../components/DetailLayout";
import ExerciseTopicsHeader from "./components/ExerciseTopicsHeader";
import style from "./index.module.scss";
import ExerciseTopicsButtons from "./components/ExerciseTopicsButtons";
import TopicList from "./components/TopicList";
import { RouteComponentProps } from "react-router-dom";
import TopicEmpty from "./components/TopicEmpty";
import AddTopicModal from "./components/AddTopicModal";
import useModalHandler from "utils/useModalHandler";
import TopicCloneModal from "./components/TopicCloneModal";
import ExerciseCloneModal from "./components/ExerciseCloneModal";
import useRequest from "utils/useRequest";
import {
    getQuestionCourseInfo,
    getQuestionList,
    QuestionType,
    saveQuestion
} from "service/exercise";
import { Button, message, Spin } from "antd";
import TopicContent from "./components/TopicContent";

interface ExerciseTopicsProps {
    id: string;
}

export default function ExerciseTopics({
    match
}: RouteComponentProps<ExerciseTopicsProps>) {
    const paperId = match.params.id;
    const addModal = useModalHandler();
    const cloneModal = useModalHandler();
    const exerciseModal = useModalHandler();
    const [checked, setChecked] = useState<number>(); //当前选中第一项

    const [courseInfoList] = useRequest(() => getQuestionCourseInfo());
    const [dataList, { loading }, refreshData] = useRequest(
        () => getQuestionList(paperId),
        {},
        [paperId]
    );
    const currentData = dataList?.find(item => item.id === checked);
    const currentIndex =
        dataList && dataList.length !== 0
            ? dataList.findIndex(item => item.id === checked)
            : 0;

    useEffect(() => {
        if (dataList && dataList.length !== 0) {
            if (!checked || !currentData) {
                setChecked(dataList[0].id);
            }
        }
    }, [dataList]);

    async function onAddTopic(data: QuestionType) {
        await saveQuestion({ ...data, paperId });
        message.success("添加成功!");
        refreshData();
    }

    return (
        <DetailLayout breadcrumb="练习详情">
            <Spin spinning={loading}>
                <ExerciseTopicsHeader
                    exerciseId={paperId}
                    visible={dataList && dataList.length > 0 ? true : false}
                />
                <ExerciseTopicsButtons
                    data={dataList || []}
                    onAdd={addModal.open}
                    onCloneTopic={cloneModal.open}
                    onCloneExercise={exerciseModal.open}
                />

                <div className={style.main}>
                    <div className={style.left}>
                        {dataList && dataList?.length !== 0 && (
                            <TopicList
                                data={dataList}
                                checked={checked}
                                exerciseId={paperId}
                                onChange={(val: number) => setChecked(val)}
                                handleOrder={refreshData}
                            />
                        )}
                    </div>

                    {dataList && dataList.length !== 0 && (
                        <div className={style.right}>
                            {currentData && (
                                <TopicContent
                                    currentData={currentData}
                                    exerciseId={paperId}
                                    refreshData={refreshData}
                                />
                            )}

                            <div className={style.footer}>
                                {currentIndex !== 0 && (
                                    <Button
                                        type="link"
                                        className={style.prev}
                                        onClick={() =>
                                            setChecked(
                                                dataList[currentIndex - 1].id
                                            )
                                        }>
                                        上一题
                                    </Button>
                                )}
                                {currentIndex !== dataList.length - 1 && (
                                    <Button
                                        type="link"
                                        className={style.next}
                                        onClick={() =>
                                            setChecked(
                                                dataList[currentIndex + 1].id
                                            )
                                        }>
                                        下一题
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}

                    {(!dataList || dataList.length === 0) && (
                        <TopicEmpty onAdd={addModal.open} />
                    )}
                </div>
            </Spin>

            {addModal.render(
                <AddTopicModal title="添加题目" onOk={onAddTopic} />
            )}
            <TopicCloneModal
                visible={cloneModal.visible}
                onCancel={cloneModal.close}
                onOk={refreshData}
                courseInfoList={courseInfoList || []}
            />
            <ExerciseCloneModal
                visible={exerciseModal.visible}
                onCancel={exerciseModal.close}
                onOk={refreshData}
                curQuestionNum={String(dataList?.length) || "0"}
                courseInfoList={courseInfoList || []}
            />
        </DetailLayout>
    );
}
